var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('router-view'),(_vm.showLogin)?_c('login',{attrs:{"showLogin":_vm.showLogin},on:{"close":_vm.closeLogin}}):_vm._e(),(_vm.showExamination)?_c('Examination',{attrs:{"showExamination":_vm.showExamination},on:{"close":_vm.closeExamination}}):_vm._e()],1),_c('SDAUfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }